import axios from 'src/api/axiosInstances/privateAxiosInstance';
import {
  QaErrorsList,
  QaErrorDetailsList,
  QaSiteCodeList,
  QaScriptNameList,
  ErrorMessagesList,
  SideCodesFilterResponse,
  ScriptNamesFilterResponse,
  ErrorCodesFilterResponse,
  QaErrorsTimestamp,
} from '../types/QaErrors';
import { Apps } from '../types/scriptConfiguration';
import { ScriptState, EnableDisableStatus, ScriptStatusReasons } from '../types/ScriptState';
import { ScriptConfigurationParams } from '../services/scriptConfiguration.service';

export const getQaErrors = async (params: QaErrorsList.Request): Promise<QaErrorsList.Response> => {
  return axios.get('/qs/qatab/geterrorslist', { params });
};

export const getQaErrorDetails = async (
  params: ScriptConfigurationParams
): Promise<QaErrorDetailsList.Response> => {
  return axios.get('/qs/qatab/geterrordetailslist', { params });
};

export const getLastRefreshTimestamp = async (): Promise<QaErrorsTimestamp> => {
  return axios.get('/qs/qatab/getLastRefreshTimestamp');
};

export const getQaSiteCodeList = async (): Promise<QaSiteCodeList.Response> => {
  return axios.get('/qs/qatab/getsitecodelist');
};

export const getQaScriptNameList = async (): Promise<QaScriptNameList.Response> => {
  return axios.get('/qs/qatab/getscriptname');
};

export const getScriptStatusReasons = async (isActive: boolean): Promise<ScriptStatusReasons.Response> => {
  return axios.get('/qs/qatab/getScriptStatusReasonsList', { params: { isActive } });
};

export const getScriptState = async (params: ScriptState.Params): Promise<ScriptState> => {
  return axios.get('/qs/qatab/getCurrentScriptStates', { params });
};

export const enableDisableScript = async (
  params: ScriptState.Params,
  body: ScriptState.RequestBody
): Promise<EnableDisableStatus> => {
  return axios.post('/qs/qatab/enableDisableScriptStatus', body, { params });
};

export const getErrorMessagesList = async (_params: ErrorMessagesList.Request): Promise<ErrorMessagesList.Response> => {
  // TODO: has to be updated once API is done
  const errorMessages: ErrorMessagesList.Item[] = [
    { count: 4, message: 'No product details found on this URL: "https://www.bookbeat.fr/livre/324498"' },
    { count: 2, message: 'No product details found on this URL: "https://www.bookbeat.fr/livre/569797"' },
    { count: 1, message: 'No product details found on this URL: "https://www.bookbeat.fr/livre/1156131"' },
    { count: 3, message: 'No product details found on this URL: "https://www.bookbeat.fr/livre/36561"' },
    { count: 1, message: 'No product details found on this URL: "https://www.bookbeat.fr/livre/647441"' },
    { count: 1, message: 'No product details found on this URL: "https://www.bookbeat.fr/livre/574394"' },
    { count: 6, message: 'No product details found on this URL: "https://www.bookbeat.fr/livre/574433"' },
    { count: 9, message: 'No product details found on this URL: "https://www.bookbeat.fr/livre/1158629"' },
  ];
  const response: ErrorMessagesList.Response = {
    errorCode: 300,
    messagesList: errorMessages,
    totalRecords: '1',
  };
  return new Promise((resolve) => setTimeout(() => resolve(response), 1000));

  return axios.get('/qs/qatab/__getErrorMessagesList__');
};

export const getAppsFilter = (): Promise<Apps.Response> => {
  return axios.get('/qs/qatab/getApplicationList');
};
export const getSideCodesFilter = (): Promise<SideCodesFilterResponse> => {
  return axios.get('/qs/qatab/getsitecodelist');
};
export const getScriptNamesFilter = (): Promise<ScriptNamesFilterResponse> => {
  return axios.get('/qs/qatab/getscriptname');
};
export const getErrorCodesFilter = (): Promise<ErrorCodesFilterResponse> => {
  return axios.get('/qs/qatab/getErrorCodesList');
};
